import { render, staticRenderFns } from "./bannerForm.vue?vue&type=template&id=5a2a3f0a&scoped=true&"
import script from "./bannerForm.vue?vue&type=script&lang=js&"
export * from "./bannerForm.vue?vue&type=script&lang=js&"
import style0 from "./bannerForm.vue?vue&type=style&index=0&id=5a2a3f0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2a3f0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a2a3f0a')) {
      api.createRecord('5a2a3f0a', component.options)
    } else {
      api.reload('5a2a3f0a', component.options)
    }
    module.hot.accept("./bannerForm.vue?vue&type=template&id=5a2a3f0a&scoped=true&", function () {
      api.rerender('5a2a3f0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/user/components/bannerForm.vue"
export default component.exports